import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import TodayIcon from "@mui/icons-material/Today";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";

const ChangePeriod = ({ state, setState }) => {
  const navigate = useNavigate();
  const [newPeriod, setPeriod] = useState("month");
  const [isLoading, setIsLoading] = useState(false);

  const handlePeriodChange = (event) => {
    setPeriod(event.target.value);
  };

  const WhatsAppLink =
    "https://wa.me/525577460177?text=" +
    encodeURIComponent("Hola, quiero cambiar mi periodicidad a mensual");

  return (
    <>
      <TitleHeaders
        title={`${state.userName}, entendemos que puedas tener algunas dificultades.`}
      />
      <Typography variant="body1" sx={{ marginBottom: 2, color: "#000" }}>
        Por eso te ofrecemos la opción de cambiar la periodicidad de tu seguro
        <span role="img" aria-label="wink">
          😉
        </span>
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: 2, color: "#000" }}>
        Te ofrecemos cambiar tu periodicidad a <strong>mensual</strong> y los
        beneficios de cambiar la periodicidad son:
        <ul>
          <li>Baja tu prima a pagar</li>
          <li>Sigues acumulando meses en tu programa de lealtad</li>
          <li>
            Evitar la cancelación podría ahorrarte costos si decides reactivar
          </li>
        </ul>
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "center",
          marginBottom: 4,
          marginTop: 4,
        }}
      >
        <FormControl variant="standard" sx={{ minWidth: 120 }}>
          <InputLabel>Periodicidad</InputLabel>
          <Select
            value={newPeriod}
            onChange={handlePeriodChange}
            label="Periodicidad"
            readOnly
          >
            <MenuItem value="month">Mensual</MenuItem>
            <MenuItem value="3month">Trimestral</MenuItem>
            <MenuItem value="6month">Semestral</MenuItem>
            <MenuItem value="year">Anual</MenuItem>
          </Select>
        </FormControl>
        <Typography variant="body1" sx={{ marginLeft: 2 }}>
          periodo
        </Typography>
      </Box>

      <Box
        textAlign={"center"}
        justifyContent={"center"}
        width={"100%"}
        display={"flex"}
        padding={0}
        margin={0}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 1,
            margin: "0px auto",
            fontSize: "20px",
            fontWeight: 600,
            width: "100%",
            borderRadius: "20px",
            backgroundColor: "#00BBEE",
            textAlign: "center",
            color: "#fff",
          }}
          onClick={() => window.open(WhatsAppLink)}
        >
          {isLoading ? (
            <CircularProgress sx={{ color: "#fff" }} />
          ) : (
            <>
              <TodayIcon
                sx={{ marginRight: 1, color: "#fff" }}
                fontSize="medium"
              />
              Cambiar periodicidad
            </>
          )}
        </Box>
      </Box>
    </>
  );
};
export default ChangePeriod;
